import Skeleton from "@mui/material/Skeleton";
import React, { useId } from "react";

export const getRandomSkeletonCount = () => {
  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  // Generate a number between 2 and 5 (inclusive)
  return (array[0] % 4) + 2;
};

interface GeneralPageSkeletonProps {
  count?: number;
  style?: React.CSSProperties;
}

const GeneralPageSkeleton: React.FC<GeneralPageSkeletonProps> = ({
  count,
  style,
}) => {
  const skeletonCount = count ?? getRandomSkeletonCount();
  const baseId = useId();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "2rem",
        width: "100%",
        minHeight: "150px",
        padding: "60px",
        height: "100vh",
        background: "rgb(255, 255, 255)",
        ...style,
      }}
    >
      {Array.from({ length: skeletonCount }).map((_, idx) => (
        <Skeleton
          data-testid={`general-page-skeleton`}
          key={`${baseId}-skeleton-${skeletonCount}-${idx}`}
          variant="rounded"
          height={240}
          sx={{ maxWidth: "1280px" }}
          width="100%"
        />
      ))}
    </div>
  );
};

export default GeneralPageSkeleton;
